import { gql, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Icon } from "../../Icon/Icon";
import { knownApps } from "../LoginAppSelect/LoginAppSelect";
import "./LoginSelectDetailedApp.css";

export const LoginSelectDetailedApp = () => {
  const [apps, setApps] = useState([]);
  /** @type {*} */
  const { app } = useParams();
  const { t } = useTranslation();

  const { data } = useQuery(getUserInformation);

  const baseUrl =
    app === "workflow"
      ? knownApps[0].goToUrl
      : app === "inventory"
      ? knownApps[1].goToUrl
      : "";

  useEffect(() => {
    let timeout;
    if (data) {
      const apps = data?.user?.roles[app];
      setApps(apps);
      if (apps.length === 1) {
        timeout = setTimeout(() => {
          handleGoToApp(`${baseUrl}/?account_id=${apps[0].applicationId}`);
        }, 1500);
      }
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [setApps, data, app, baseUrl]);

  const handleGoToApp = (url) => {
    window.open(url, "_self");
  };

  return (
    <div className="LoginSelectDetailedApp">
      <div className="LoginAppSelect">
        {apps.length > 1 && (
          <div className="LoginSelectDetailedApp__title">
            {t("loginForm.selectAccount")}
          </div>
        )}
        {apps.length > 1 &&
          apps.map((app) => (
            <LoginSelectDetailedAppItem
              key={app.applicationId}
              name={app.applicationName}
              icon="menuAccounts"
              onClick={() =>
                handleGoToApp(`${baseUrl}/?account_id=${app.applicationId}`)
              }
            />
          ))}
        {apps.length === 1 && (
          <>
            <div className="LoginSelectDetailedApp__redirect">
              {t("loginForm.redirecting")}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const getUserInformation = gql`
  query {
    user {
      id
      email
      roles
      prefferedLanguage
    }
  }
`;

const LoginSelectDetailedAppItem = ({ name, icon, onClick = () => {} }) => {
  const { t } = useTranslation();
  return (
    <div className="LoginSelectDetailedAppItem" onClick={onClick}>
      <div className="LoginSelectDetailedAppItem__icon">
        <Icon name={icon} width={30} height={30} />
      </div>
      <div className="LoginSelectDetailedAppItem__text">{name}</div>
      <div className="LoginSelectDetailedAppItem__action">
        <div className="LoginSelectDetailedAppItem__action-text">
          {t("generic.select")}
        </div>
        <Icon name="iconDropdown" width={12} height={7} />
      </div>
    </div>
  );
};
